export default __webpack_public_path__ + "static/media/bimeh-novin@2x.d310a0f2.png";